<template>
    <section class="pt-0 pb-0">
        <div class="token-container">
            <div class="flex justify-center">
            <img class="component-header flex justify-center mb-10" src="images/tokenomics.png">
        </div>
            <div class="sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid gap-6">
                <div class="grid-item">
                    <img class="grid-img" src="images/mint.png">
                    <h3 class="grid-text">Mint & Freeze Revoked</h3>
                </div>
                <div class="grid-item">
                    <img class="grid-img flex justify-center" src="images/taxes.png">
                    <h3 class="grid-text">Zero Taxes</h3>
                </div>
                <div class="grid-item">
                    <img class="grid-img" src="images/liq_burn.png">
                    <h3 class="grid-text">Liquidity Burned</h3>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'TokenomicsPage'
};
</script>

<style>
.grid-item {
    display: flex;
    flex-direction: column;
    align-items: center; /* Center items horizontally */
    justify-content: center; /* Center items vertically */
    background-color: #fbbe9b;
    border: 2px solid black; /* Add black border */
    border-radius: 8px; /* Add border radius for rounded corners */
    padding: 20px; /* Add padding for better spacing */
}

.grid-img {
    width: 200;
    height: auto;
}

.token-container {
    padding: 5% 20%;
}

.grid-text {
    color: black;
    font-size: 1.5rem;
    font-weight: bold;
}
</style>

